import { createAction } from '@reduxjs/toolkit';

export const closestDatesStartSearchAsyncAction = createAction<string>(
  'CLOSET_DATES/START_SEARCH_ASYNC_ACTION',
);

export const choseNeighboringDateAnalyticsAction = createAction<{
  nightsCount: number;
}>('CLOSET_DATES/CHOSE_NEIGHBORING_DATE_ANALYTICS_ACTION');
